import { KEY_LOCALSTORAGE } from "../auth/core/_consts";
import { ROLE } from "./Constant";
import { localStorageItem } from "./LocalStorage";

export const hasAuthority = (permission: string): boolean => {
  if (ROLE.NHOM_NGHIEN_CUU === permission) return true;
  let authorities = localStorageItem.get(KEY_LOCALSTORAGE.AUTHORITIES);
  return authorities?.[permission];
}
